define(["exports", "react-intl-universal"], function (_exports, _reactIntlUniversal) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.initIntl = initIntl;
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);

  function initIntl(i18n, currentLocale) {
    var _locales;

    if (i18n === void 0) {
      i18n = {};
    }

    if (currentLocale === void 0) {
      currentLocale = '';
    }

    var locales = (_locales = {}, _locales[currentLocale] = i18n, _locales);
    return new Promise(function (resolve) {
      _reactIntlUniversal.default.init({
        currentLocale: currentLocale,
        locales: locales
      }).then(resolve());
    });
  }
});